import script from "./SnMycarInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SnMycarInfo.vue?vue&type=script&setup=true&lang=js"

import "./SnMycarInfo.vue?vue&type=style&index=0&id=70c9ae93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c9ae93"]])

export default __exports__